const BASE = {
  getUserObject: "/api/getUserObject",
  samlLogin: "/api/saml/login",
  isLoggedIn: "/api/saml/isLoggedIn"
};

export default BASE;
